import { render, staticRenderFns } from "./JobHistoryForm.vue?vue&type=template&id=6235baa2&"
import script from "./JobHistoryForm.vue?vue&type=script&lang=js&"
export * from "./JobHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./JobHistoryForm.vue?vue&type=style&index=0&id=6235baa2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports